const en_trans_initstock = {
    "": "initial stock",

    message: {
        note: "NOTE: only Excel format can be uploaded!",
        note_excel: "Download Excel template",
        note_term_title: "File requirements:",
        note_term_1: "Use the template file",
        note_term_2: "Fields marked with '*' are required",
        note_term_3: "Lot/Serial Number: required if item has serial or lot number",
        note_term_4: "Lot/Serial Number is required if the item type is serial-based",
    },

    error: {
        create: "Failed to initialize warehouse stock",
        download_file: "Failed to download file",
    },

    success: {
        create: "Warehouse stock initialized successfully",
    },
}

export default en_trans_initstock;